import React from "react";

const eventos = [
  { periodo: "13/08/2025", etapa: "Publicação do Edital de Convocação" },

  { periodo: "14/08 a 12/09/2025", etapa: "Inscrição dos candidatos (término às 17 horas do dia 12/09/2025)" },

  { periodo: "14/08 a 17/09/2025", etapa: "Análise dos pedidos de candidatura pela Comissão Geral de Eleição - CGE" },

  { periodo: "18/09/2025", etapa: "Divulgação dos nomes dos candidatos inscritos" },

  { periodo: "19/09 a 24/09/2025", etapa: "Impugnação de candidaturas e recursos junto à CGE" },

  { periodo: "19/09 a 30/09/2025", etapa: "Julgamento das impugnações e recursos pela CGE" },

  { periodo: "01/10/2025", etapa: "Divulgação dos nomes dos candidatos aptos a serem votados e início do período para divulgação do material de campanha pelos candidatos" },

  { periodo: "21/10/2025", etapa: "Data final para apresentação ou alteração do Material de Divulgação da Campanha (término às 17 horas)" },

  { periodo: "22/10 a 11/11/2025", etapa: "Votação - início às 9 horas do dia 22/10/2025 e término às 17 horas do dia 11/11/2025" },

  { periodo: "11/11/2025", etapa: "Apuração dos votos pela CGE" },

  { periodo: "11/11/2025", etapa: "Divulgação do resultado da apuração" },

  { periodo: "12/11 a 17/11/2025", etapa: "Interposição de recursos sobre a apuração" },

  { periodo: "12/11 a 21/11/2025", etapa: "Exame e julgamento dos recursos sobre a apuração pela CGE" },
  { periodo: "21/11 a 26/11/2025", etapa: "Julgamento final, pelo Conselho de Administração, de assuntos relativos à nulidade do processo eleitoral" },
  { periodo: "01/12/2025", etapa: "Proclamação dos eleitos e divulgação do resultado final da eleição" },
  { periodo: "01/01/2026", etapa: "Início do mandato dos Delegados eleitos" },

  ,
];

const Cronograma = () => {
  return (
    <section id="cronograma" className="  py-10 px-4">
      <div className="  mx-auto text-center">
        {/* Título */}
        <h2 className="text-xl sm:text-xl font-bold mb-2">CRONOGRAMA</h2>

        {/* Linha amarela */}
        <div className="w-24 h-1 bg-[#f6b100] mx-auto mb-6" />

        {/* Tabela */}
        <div className="overflow-hidden rounded-lg border border-gray-300">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="  text-black text-sm sm:text-base font-semibold">
                <th className="px-4 py-3">PERÍODO</th>
                <th className="px-4 py-3">ETAPA</th>
              </tr>
            </thead>
            <tbody className="text-sm sm:text-base text-gray-800">
              {eventos.map((item, index) => (
                <tr
                  key={index}
                  className={`${index % 2 === 0 ? "bg-white" : "bg-gray-100"} border-b border-gray-200`}
                >
                  <td className="px-4 py-2 font-medium  w-1/4">{item.periodo}</td>
                  <td className="px-4 py-2">{item.etapa}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default Cronograma;
